import { css } from 'emotion'

export const wrapper = css({
  overflowY: 'auto',
  height: '100vh',
})
